import { nanoid } from '@ant-design/pro-components';
import { Form, Input, Modal, message } from 'antd';
import { FormLayout, useWatch } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import QuestionItem from 'pages/khaosat/Session/QuestionItem';
import { Question, QuestionType, Session as SessionModel } from 'pages/khaosat/models';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { surveyPresenter } from 'stores/root_store';

type Props = {
  sessionQues: SessionModel;
  handleDelete: (idSession?: string) => void;
  index: number;
};

type QuestionList = Question[] | undefined;

const Session = ({ sessionQues, handleDelete, index }: Props) => {
  const [form] = Form.useForm();

  const { t } = useTranslation();

  const [formLayout, setFormLayout] = useState<FormLayout>('horizontal');
  const [renderQues, setRenderQues] = useState(useWatch('questions', form) as QuestionList);

  const [checkQuesApi, setCheckQuesApi] = useState(false)

  const formItemLayout = formLayout === 'horizontal' ? { labelCol: { span: 4 }, wrapperCol: { span: 20 } } : null;
  const buttonItemLayout = formLayout === 'horizontal' ? { labelCol: { span: 4 }, wrapperCol: { span: 20 } } : null;
  // ================================================================================================================

  useEffect(() => {
    setRenderQues(form.getFieldValue('questions') as QuestionList);
  }, [form.getFieldValue('questions')]);

  // handle add question
  const handleAddQues = () => {
    const questionsAdd = cloneDeep(form.getFieldValue('questions') as QuestionList);
    questionsAdd?.push({
      id: nanoid(),
      type: QuestionType.QUIZ,
    });
    form.setFieldValue('questions', questionsAdd);
  };

  // handle delete question
  const handleDeleteQues = (quesId: string) => {
    const tempt = cloneDeep(form.getFieldValue('questions') as QuestionList);
    const filteredQuestions = tempt?.filter((item) => item.id !== quesId);
    form.setFieldValue('questions', filteredQuestions);
  };

  // handle delete section
  // const handleDeleteSection = () => {
  //   handleDelete(sessionQues.id);
  // };

  const handleSetSurveySession = () => {
    const event = new CustomEvent('setSurvey', { detail: { [`session-${sessionQues.id}`]: form } });
    document.dispatchEvent(event);
  };

  // giá trị ban đầu của question trong phần (Session)
  const initialValues = {
    id: sessionQues.id,
    sectionId: sessionQues.id,
    title: sessionQues.title || '',
    description: sessionQues.description || '',
    questions: sessionQues?.questions
      ? sessionQues?.questions
      : [
        {
          id: nanoid(),
          type: QuestionType.QUIZ,
        },
      ],
    layout: formLayout,
  };

  useEffect(() => {
    document.addEventListener('previewSurvey', handleSetSurveySession);
    return () => {
      document.removeEventListener('previewSurvey', handleSetSurveySession);
    };
  }, []);

  return (
    <div className="w-full flex flex-col rounded mb-2 relative pt-[12px] px-4">
      <Form
        {...formItemLayout}
        form={form}
        className="!mt-8"
        initialValues={initialValues}
        onFinish={(value) => { }}
        style={{ maxWidth: formLayout === 'inline' ? 'none' : '100%' }}
        layout={formLayout}
      >
        <div className="rounded-lg relative !mb-3">
          {/* Tên phần */}
          <div
            className={`bg-primary absolute top-[-30px] z-20 left-0 rounded-lg w-32 h-10 text-white flex items-center justify-center text-lg font-bold`}
          >
            Phần {index + 1}
          </div>
          <div className="bg-primary rounded-tr-lg h-4"></div>
          <div className="p-3 md:p-3 bg-white !rounded-[3px] shadow-box">
            {/* tiêu đề */}
            <Form.Item
              {...buttonItemLayout}
              name="title"
              className="!mb-6 md:w-1/2"
              label="Tiêu đề"
            // rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            {/* mô tả */}
            <Form.Item
              {...buttonItemLayout}
              name="description"
              className="!mb-0 md:w-1/2"
              label="Mô tả"
            >
              <TextArea rows={2} />
            </Form.Item>
            {/* thêm câu hỏi */}
            <Form.Item
              label
              labelCol={{ span: 11 }}
              wrapperCol={{ span: 13 }}
              colon={false}
              className="!m-0 flex justify-center md:justify-start"
            >
              <CustomButton className="mt-4" type="primary" onClick={handleAddQues}>
                Thêm câu hỏi
              </CustomButton>
            </Form.Item>
            {/* Xóa phần */}
            <Form.Item className="!m-0 absolute bottom-3 right-3">
              {/* <Popconfirm
                title="Xóa"
                description={(checkQuesApi ? 'Phần này có chứa câu hỏi đã được khách hàng trả lời.  Bạn có chắc muốn xóa câu hỏi này?' : 'Bạn có chắc muốn xóa câu hỏi này?')}
                onConfirm={async () => {
                  handleDelete(sessionQues.id)
                }}
                okButtonProps={{
                  style: {
                    background: 'red',
                  },
                }}
                placement="topRight"
                okText="Yes"
                cancelText="No"
              > */}

              <CustomButton type='primary' onClick={async () => {
                const result = await surveyPresenter.deleteSessionInQuesSurvey(sessionQues.id!)
                if (result.data) {
                  message.warning('Phần này có chứa câu hỏi đã được khách hàng trả lời')
                }
                setCheckQuesApi(result.data)
                const instance = Modal.confirm({
                  title: "Xóa",
                  content: checkQuesApi ? 'Phần này có chứa câu hỏi đã được khách hàng trả lời. Bạn có chắc muốn xóa câu hỏi này?' : 'Bạn có chắc muốn xóa câu hỏi này?',
                  onOk: async () => {
                    handleDelete(sessionQues.id)
                  },
                  footer: (
                    <div className="flex gap-4 justify-end mt-4">
                      <CustomButton
                        onClick={() => {
                          instance.destroy();
                        }}
                      >
                        {t('btn.cancel')}
                      </CustomButton>
                      <CustomButton
                        className='!text-white hover:bg-[#fff] '
                        color='#209de0'
                        onClick={() => {
                          instance.destroy();
                        }}
                      >
                        {t('btn.continue')}
                      </CustomButton>
                    </div>
                  ),

                })
              }}
                className="text-xl text-red-500 cursor-pointer">Xóa phần</CustomButton>
            </Form.Item>
            <Form.Item name="id" hidden><Input /></Form.Item>
            <Form.Item name="questions" hidden ><Input /></Form.Item>
            <Form.Item name="sectionId" hidden><Input /></Form.Item>
          </div>
        </div>
        {
          renderQues?.map((item, index) => {
            return (
              <QuestionItem
                key={index}
                form={form}
                sessionId={sessionQues.id}
                item={item}
                index={index}
                onDelete={handleDeleteQues}
              />
            );
          })
        }
        {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Test
          </Button>
        </Form.Item> */}
      </Form >
    </div >
  );
};

export default Session;
